import { createContext } from 'react';

export const LeagueManageContext = createContext<{ handleRefetchData?: any }>(
  {},
);
